import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Pagination } from "@mui/material";
import usePagination from "../utils/Pagination";
import { Typography } from "@mui/material";
import { Container } from "react-bootstrap";
import { makeStyles } from "@mui/styles";
import video_gallary from "../../public/media/media/img/video_gallary.png";
import news1 from "../../public/media/media/img/news1.png";
import news2 from "../../public/media/media/img/news2.png";
import news3 from "../../public/media/media/img/news3.png";
import news4 from "../../public/media/media/img/news4.png";
import news5 from "../../public/media/media/img/news5.png";
import news6 from "../../public/media/media/img/news6.png";
import news7 from "../../public/media/media/img/news7.png";
import news8 from "../../public/media/media/img/news8.png";
import news9 from "../../public/media/media/img/news9.png";
import news10 from "../../public/media/media/img/news10.png";
import news13 from "../../public/media/media/img/news13.png";
import news14 from "../../public/media/media/img/news14.png";
import news15 from "../../public/media/media/img/news15.png";
import news16 from "../../public/media/media/img/news16.png";
import news17 from "../../public/media/media/img/news17.png";
import news18 from "../../public/media/media/img/news18.png";
import news19 from "../../public/media/media/img/news19.png";
import news20 from "../../public/media/media/img/news20.png";
import news21 from "../../public/media/media/img/adcp.png";
import news22 from "../../public/media/media/img/mobile snap.png";
import news23 from "../../public/media/media/img/cotton day.png";
import news24 from "../../public/media/media/img/deselting award.png";
import news25 from "../../public/media/media/img/foa visit.png";
import news26 from "../../public/media/media/img/indepemdence day.png";
import news27 from "../../public/media/media/img/plantettion day.png";
import news28 from "../../public/media/media/img/lims ffc day.png";
import news29 from "../../public/media/media/img/topi rak.png";
import news30 from "../../public/media/media/img/soil day.png";
import news31 from "../../public/media/media/img/gis.png";
import news34 from "../../public/media/media/img/vol day.png";
import news32 from "../../public/media/media/img/news55.jpg";
import news33 from "../../public/media/media/img/Datafest 2024.jpg";
import interview1 from '../../public/media/media/img/interview.png';
import Blogs from "./blog";
import Main from "./reports";
import video1 from "../../public/media/media/vid/video1.mp4";
import video2 from "../../public/media/media/vid/video2.mp4";
import video3 from "../../public/media/media/vid/video3.mp4";
import video4 from "../../public/media/media/vid/video4.mp4";
import video5 from "../../public/media/media/vid/video5.mp4";
import video6 from "../../public/media/media/vid/video6.mp4";
import video7 from "../../public/media/media/vid/video7.mp4";
import video8 from "../../public/media/media/vid/video8.mp4";
import video9 from "../../public/media/media/vid/video9.mp4";
import video10 from "../../public/media/media/vid/video10.mp4";
import video13 from "../../public/media/media/vid/video13.mp4";
import video14 from "../../public/media/media/vid/video14.mp4";
import video15 from "../../public/media/media/vid/video15.mp4";
import video16 from "../../public/media/media/vid/video16.mp4";
import video17 from "../../public/media/media/vid/video17.mp4";
import video18 from "../../public/media/media/vid/video18.mp4";
import video19 from "../../public/media/media/vid/video19.mp4";
import video20 from "../../public/media/media/vid/video20.mp4";
import video21 from "../../public/media/media/vid/1- Adpc Video.mp4";
import video22 from "../../public/media/media/vid/23-10.mp4";
import video23 from "../../public/media/media/vid/cotton.mp4";
import video24 from "../../public/media/media/vid/Desilting campaign- Award Ceremony Final.mp4";
import video25 from "../../public/media/media/vid/Fao Lims Visit.mp4";
import video26 from "../../public/media/media/vid/Independence Day Video.mp4";
import video27 from "../../public/media/media/vid/Lims Plantation Drive.mp4";
import video28 from "../../public/media/media/vid/Lims-Ffc Joint Knowledge Sharing Session 24Th July 2024.mp4";
import video29 from "../../public/media/media/vid/Topi Rakh Event Video.mp4";
import  video30 from "../../public/media/media/vid/Soil day.mp4";
import  video31 from "../../public/media/media/vid/GIS Video.mp4";
import  video32 from "../../public/media/media/vid/Food Day Final Video.mp4";
import  video33 from "../../public/media/media/vid/Datafest 2024.mp4";
import  video34 from "../../public/media/media/vid/Volunteer Day Final.mp4";


import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";

const useStyles = makeStyles(() => ({
  ul: {
    "& .MuiPaginationItem-root": {
      border: "1px solid #0E97FF",
      color: "#0E97FF",
    },
    "& .Mui-selected": {
      color: "#0E97FF",
      background: "#0E97FF",
    },
  },
}));

function Videogallery({ image, text, height, title }) {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");
  const [selectedButton, setSelectedButton] = useState(1);
  const handleButtonClick = (buttonId) => {
    setSelectedButton(buttonId);
  };
  const buttonStyle = {
    backgroundColor: "white",
    color: "#0E97FF",
    border: "1px dashed #0E97FF",
    borderRadius: "50px",
    fontSize: "12px",
    fontWeight: "700",
    padding: "10px 32px",
    textTransform: "uppercase",
    width: "230px",
    marginRight: "5px",
    marginBottom: '10px',
    flexShrink: 0
  };

  const selectedButtonStyle = {
    backgroundColor: "#0E97FF",
    color: "white",
    border: "1px solid #0E97FF",
    borderRadius: "50px",
    fontSize: "12px",
    fontWeight: "700",
    padding: "10px 32px",
    textTransform: "uppercase",
    width: "230px",
    marginRight: "5px",
    marginBottom: '10px',
    flexShrink: 0
  };
  const cardData = [
    {
      id: 34,
      image: news34,
      title: "Volunteer Day",
      src: video34,
    },
    {
      id: 32,
      image: news32,
      title: "Food Day",
      src: video32,
    },{
      id: 33,
      image: news33,
      title: "Datafest",
      src: video33,
    },
    {
      id: 31,
      image: news31,
      title: "GIS Day",
      src: video31,
    },{
      id: 30,
      image: news30,
      title: "Soil Day",
      src: video30,
    },
    {
      id: 21,
      image: news21,
      title: "Adpc",
      src: video21,
    },
    {
      id: 22,
      image: news22,
      title: "Mission One Million – A Historic National Project by LIMS",
      src: video22,
    }, {
      id: 23,
      image: news23,
      title: "Happy Cotton Day! ",
      src: video23,
    },
    {
      id: 24,
      image: news24,
      title: "Desilting campaign- Award Ceremony",
      src: video24,
    },
    {
      id: 25,
      image: news25,
      title: "Fao Lims Visit",
      src: video25,
    },
    {
      id: 26,
      image: news26,
      title: "Independence Day",
      src: video26,
    },
    {
      id: 27,
      image: news27,
      title: "Lims Plantation Day",
      src: video27,
    },

    {
      id: 28,
      image: news28,
      title: "Lims-Ffc Joint Knowledge Sharing Session",
      src: video28,
    },
    {
      id: 29,
      image: news29,
      title: "Topi Rakh Event",
      src: video29,
    },
    {
      id: 1,
      image: news1,
      title: "Inauguration of LIMS by Prime Minister",
      src: video1,
    },
    {
      id: 7,
      image: news7,
      title: "Launch of model by CM and COAS",
      src: video7,
    }, {
      id: 10,
      image: news10,
      title: "Cotton Day, CM about LIMS",
      src: video10,
    },
    {
      id: 3,
      image: news3,
      title: "Briefing to DG IOFS",
      src: video3,
    },
    {
      id: 2,
      image: news2,
      title: "SIFC Meeting",
      src: video2,
    },
    {
      id: 8,
      image: news8,
      title: "SIFC interview part 1",
      src: video8,
    },
    {
      id: 9,
      image: news9,
      title: "SIFC interview part 2",
      src: video9,
    },

    {
      id: 4,
      image: news4,
      title: "MOU Signing with PCSIR",
      src: video4,
    },
    {
      id: 5,
      image: news5,
      title: "MOU Signing with Zee Saga",
      src: video5,
    },
    {
      id: 6,
      image: news6,
      title: "Spray against white fly attach on cotton crop",
      src: video6,
    },
    {
      id: 13,
      image: news13,
      title: "Dr Waqar Yaseen Project director LIMS",
      src: video13,
    },
    {
      id: 14,
      image: news14,
      title: "Dr Waqar Yaseen Project director LIMS",
      src: video14,
    }, {
      id: 15,
      image: news15,
      title: "Dr Waqar Yaseen Project director LIMS",
      src: video15,
    }, {
      id: 16,
      image: news16,
      title: "Dr Waqar Yaseen Project director LIMS",
      src: video16,
    }, {
      id: 18,
      image: news18,
      title: "Dr Waqar Yaseen Project director LIMS",
      src: video18,
    },
    {
      id: 19,
      image: news19,
      title: "LIMS Training Session For Irrigation DEPT",
      src: video19,
    },
    {
      id: 20,
      image: news20,
      title: "Launch LIMS Desilting Montior Application For PUNJAB Govt",
      src: video20,
    },
    {
      id: 21,
      image: news20,
      title: "Launch LIMS Desilting Montior Application For PUNJAB Govt",
      src: video20,
    },


  ];
  const interviewData = [
    {
      id: 1,
      image: interview1,
      title: "Interview About LIMS by Suno FM Radio.",
      src: 'https://limspakistan.com/admin/public/uploads/interview1.mp4',
    },
    {
      id: 17,
      image: news17,
      title: "Dr Waqar Yaseen Project director LIMS",
      src: video17,
    }


  ];
  let [page, setPage] = useState(1);
  let [pageInterview, setPageInterview] = useState(1);
  const PER_PAGE = 6;
  const count = Math.ceil(cardData.length / PER_PAGE);
  const countInterview = Math.ceil(interviewData.length / PER_PAGE);
  const _DATA = usePagination(cardData, PER_PAGE);
  const __DATA = usePagination(interviewData, PER_PAGE);
  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const handleChangeInterview = (e, p) => {
    setPageInterview(p);
    __DATA.jump(p);
  };
  const style = {
    justifyContent: "flex-start",
    display: 'flex',
    flexDirection: 'column'
  };

  const titleStyle = {
    WebkitLineClamp: 2,
    color: "#000",
    fontSize: "15.7649px",
    fontWeight: 500,
    lineHeight: "24px",
    marginBottom: "4px",
    marginTop: "5px",
    fontFamily: "Poppins",
    textAlign: 'justify',
    "@media (max-width: 786px)": {
      marginLeft: "30px",
    },
  };

  const LatestVideos = () => {
    return (
      <>
        <Row style={{ marginTop: "20px" }}>
          <Col xs={12}>
            <Typography mt="10px" variant="h5">
              <strong>Latest videos </strong>
            </Typography>
          </Col>
        </Row>
        <Row
          className="g-4"
          style={{ marginTop: "20px", marginBottom: "50px" }}
        >
          {_DATA.currentData().map((card) => (
            <Col xs={12} md={6} xl={4} key={card.id}>
              <div
                className="item"
                style={{ cursor: "pointer", position: "relative" }}
                onClick={() => {
                  setSelectedVideo(card.src); // Set the selected video URL
                  setOpen(true); // Open the modal
                }}
              >
                <Card style={{ boxShadow: "none" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <img
                      src={card.image} // Use the image property from cardData
                      alt={`img_${card.id}`}
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="60"
                      viewBox="0 0 39 39"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: 48,
                      }}
                      fill="none"
                    >
                      <path
                        d="M37.7565 19.6043C37.7565 29.868 29.4356 38.1885 19.1712 38.1885C8.90673 38.1885 0.585826 29.868 0.585826 19.6043C0.585826 9.3406 8.90673 1.02015 19.1712 1.02015C29.4356 1.02015 37.7565 9.3406 37.7565 19.6043Z"
                        fill="#0E97FF"
                        fillOpacity="0.5"
                        stroke="white"
                        stroke-width="1.17165"
                      />
                      <path
                        d="M14.103 11.5678L14.1031 11.5678L28.5023 19.4869C28.5023 19.4869 28.5024 19.4869 28.5025 19.487C28.5234 19.4986 28.5409 19.5155 28.553 19.5361C28.5653 19.5568 28.5717 19.5804 28.5717 19.6043C28.5717 19.6283 28.5653 19.6519 28.553 19.6726C28.5408 19.6932 28.5233 19.7102 28.5023 19.7218L14.1031 27.6409L14.1028 27.641C14.083 27.6519 14.0608 27.6576 14.0381 27.6576C14.0026 27.6576 13.9686 27.6435 13.9435 27.6184C13.9183 27.5932 13.9042 27.5591 13.9042 27.5235V11.6852C13.9042 11.6852 13.9042 11.6852 13.9042 11.6851C13.9042 11.6619 13.9103 11.639 13.9218 11.6188C13.9334 11.5986 13.95 11.5817 13.9701 11.5698C13.9901 11.558 14.0129 11.5515 14.0363 11.5512C14.0596 11.5508 14.0826 11.5565 14.103 11.5678Z"
                        fill="white"
                        stroke="white"
                        stroke-width="1.17165"
                      />
                    </svg>
                  </div>
                  <div style={style}>
                    <Card.Title style={titleStyle}>
                      {card.title}
                    </Card.Title>
                  </div>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          <Col xs={12} style={{ display: "flex", justifyContent: "center" }}>
            <Pagination
              className={classes.ul}
              style={{ marginBottom: "25px" }}
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
            ></Pagination>
          </Col>
        </Row>
      </>
    );
  };


  const InterviewData = () => {
    return (
      <>
        <Row style={{ marginTop: "20px" }}>
          <Col xs={12}>
            <Typography mt="10px" variant="h5">
              <strong>Interview About LIMS</strong>
            </Typography>
          </Col>
        </Row>
        <Row
          className="g-4"
          style={{ marginTop: "20px", marginBottom: "50px" }}
        >
          {__DATA.currentData().map((card) => (
            <Col xs={12} md={6} xl={4} key={card.id}>
              <div
                className="item"
                style={{ cursor: "pointer", position: "relative" }}
                onClick={() => {
                  setSelectedVideo(card.src); // Set the selected video URL
                  setOpen(true); // Open the modal
                }}
              >
                <Card style={{ boxShadow: "none" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <img
                      src={card.image} // Use the image property from cardData
                      alt={`img_${card.id}`}
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="60"
                      viewBox="0 0 39 39"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: 48,
                      }}
                      fill="none"
                    >
                      <path
                        d="M37.7565 19.6043C37.7565 29.868 29.4356 38.1885 19.1712 38.1885C8.90673 38.1885 0.585826 29.868 0.585826 19.6043C0.585826 9.3406 8.90673 1.02015 19.1712 1.02015C29.4356 1.02015 37.7565 9.3406 37.7565 19.6043Z"
                        fill="#0E97FF"
                        fillOpacity="0.5"
                        stroke="white"
                        stroke-width="1.17165"
                      />
                      <path
                        d="M14.103 11.5678L14.1031 11.5678L28.5023 19.4869C28.5023 19.4869 28.5024 19.4869 28.5025 19.487C28.5234 19.4986 28.5409 19.5155 28.553 19.5361C28.5653 19.5568 28.5717 19.5804 28.5717 19.6043C28.5717 19.6283 28.5653 19.6519 28.553 19.6726C28.5408 19.6932 28.5233 19.7102 28.5023 19.7218L14.1031 27.6409L14.1028 27.641C14.083 27.6519 14.0608 27.6576 14.0381 27.6576C14.0026 27.6576 13.9686 27.6435 13.9435 27.6184C13.9183 27.5932 13.9042 27.5591 13.9042 27.5235V11.6852C13.9042 11.6852 13.9042 11.6852 13.9042 11.6851C13.9042 11.6619 13.9103 11.639 13.9218 11.6188C13.9334 11.5986 13.95 11.5817 13.9701 11.5698C13.9901 11.558 14.0129 11.5515 14.0363 11.5512C14.0596 11.5508 14.0826 11.5565 14.103 11.5678Z"
                        fill="white"
                        stroke="white"
                        stroke-width="1.17165"
                      />
                    </svg>
                  </div>
                  <div style={style}>
                    <Card.Title style={titleStyle}>
                      {card.title}
                      {/* Add any additional text or information about the video */}
                    </Card.Title>
                  </div>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          <Col xs={12} style={{ display: "flex", justifyContent: "center" }}>
            <Pagination
              className={classes.ul}
              style={{ marginBottom: "25px" }}
              count={countInterview}
              size="large"
              page={pageInterview}
              variant="outlined"
              shape="rounded"
              onChange={handleChangeInterview}
            ></Pagination>
          </Col>
        </Row>
      </>
    );
  };
  const Reports = () => {
    return (
      <Main/>
    );
  };
  

  return (
    <>
      <Card className="bg-dark text-white" style={{ marginTop: "150px" }}>
        <Card.Img
          src={video_gallary}
          alt="Card img"
          height="350px"
          style={{
            borderRadius: "0px",
            background: "rgba(25, 54, 95, 0.8)",
          }}
        />
        <Card.ImgOverlay>
          <Card.Title style={{ color: "white" }}>
            <Typography
              fontFamily="Poppins"
              variant="h3"
              style={{
                textAlign: "center",
                display: "block",
                fontSize: "40px",
                lineHeight: "46px",
                letterSpacing: ".01em",
                fontWeight: 800,
              }}
              sx={{ marginTop: { xs: "100px", md: "100px" } }}
            >
              Video{" "}
              <span
                style={{
                  WebkitTextStroke: "1px",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Gallery
              </span>
            </Typography>
          </Card.Title>
          <Card.Text></Card.Text>
          <Card.Text color="primary">{text}</Card.Text>
        </Card.ImgOverlay>
      </Card>
      <Container>
      <Box
  style={{
    display: "flex",
    justifyContent: "start",
    marginBottom: "10px",
    marginTop: "25px",
    overflowX: "auto"
  }}
>
  <Button
    style={selectedButton === 1 ? selectedButtonStyle : buttonStyle}
    onClick={() => handleButtonClick(1)}
  >
    Latest Videos
  </Button>

  <Button
    style={selectedButton === 2 ? selectedButtonStyle : buttonStyle}
    onClick={() => handleButtonClick(2)}
  >
    Interview About LIMS
  </Button>

  {/* Add Reports Button */}
  <Button
    style={selectedButton === 3 ? selectedButtonStyle : buttonStyle}
    onClick={() => handleButtonClick(3)}
  >
    Reports
  </Button>
  <Button
    style={selectedButton === 4 ? selectedButtonStyle : buttonStyle}
    onClick={() => handleButtonClick(4)}
  >
    Blogs
  </Button>
</Box>

{
  selectedButton === 1 ? (
    <LatestVideos />
  ) : selectedButton === 2 ? (
    <InterviewData />
  ) : selectedButton === 3 ? (
    <Reports />
  ) : (
    <Blogs />
  )
}


      </Container>
      <ModalVideo
        channel="custom"
        url={selectedVideo}
        isOpen={isOpen}
        onClose={() => {
          setSelectedVideo(""); // Clear the selected video URL
          setOpen(false); // Close the modal
        }}
      />
    </>
  );
}

export default Videogallery;
